import { Ticket, TicketStatus } from "@signalist/shared-types";

/**
 * The customer's tabs. The four named buckets **partition** the ticket set (PREC-3937 decision 1):
 * "Active" is what Signalist still owes an answer on, "Needs your reply" is what the customer owes,
 * and no ticket is counted twice — so the four counts always sum to All.
 */
export enum SupportTicketTab {
	ALL = "ALL",
	ACTIVE = "ACTIVE",
	NEEDS_REPLY = "NEEDS_REPLY",
	RESOLVED = "RESOLVED",
	CLOSED = "CLOSED",
}

/** Render order of the tab strip. */
export const SUPPORT_TICKET_TABS: SupportTicketTab[] = [
	SupportTicketTab.ALL,
	SupportTicketTab.ACTIVE,
	SupportTicketTab.NEEDS_REPLY,
	SupportTicketTab.RESOLVED,
	SupportTicketTab.CLOSED,
];

/** `null` means "every status" (the All tab). */
export const TAB_STATUSES: Record<SupportTicketTab, TicketStatus[] | null> = {
	[SupportTicketTab.ALL]: null,
	[SupportTicketTab.ACTIVE]: [TicketStatus.OPEN, TicketStatus.WAITING_ON_US],
	[SupportTicketTab.NEEDS_REPLY]: [TicketStatus.WAITING_ON_CUSTOMER],
	[SupportTicketTab.RESOLVED]: [TicketStatus.RESOLVED],
	[SupportTicketTab.CLOSED]: [TicketStatus.CLOSED],
};

export const matchesTab = (ticket: Ticket, tab: SupportTicketTab): boolean => {
	const statuses = TAB_STATUSES[tab];

	return statuses === null || statuses.includes(ticket.status);
};

export type TicketTabCounts = Record<SupportTicketTab, number>;

export const countTicketTabs = (tickets: Ticket[]): TicketTabCounts =>
	SUPPORT_TICKET_TABS.reduce((counts, tab) => {
		counts[tab] = tickets.filter((ticket) => matchesTab(ticket, tab)).length;

		return counts;
	}, {} as TicketTabCounts);
